
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/providers/success",
      function () {
        return require("private-next-pages/providers/success.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/providers/success"])
      });
    }
  